import convertColorToCss from '../color/convertColorToCss.js';
import convertPtToPx from '../../units/convertPtToPx.js';

/**
 * Polotno uses middle. Prawn uses center.
 * @param {string} value
 * @returns {string}
 */
const convertVerticalAlignToPolotno = value => {
  if (value === 'top' || value === 'bottom') {
    return value;
  }
  if (value === 'middle' || value === 'center') {
    return 'middle';
  }
  return 'top';
};

/**
 * Converts the Parabo text placeholder specification format to Polotno format.
 * @param {object} spec Parabo text placeholder specification data
 * @param {object} defaultProps Default Polotno Text Element props
 * @returns {object} Polotno text element style properties
 */
const convertTextSpecToPolotno = (spec, defaultProps = {}) => {
  const align = spec.alignment ?? defaultProps.align;
  const verticalAlign = spec.verticalAlignment ?? defaultProps.verticalAlign;
  const color = spec.color ?? defaultProps.fill;
  const fontFamily = spec.fontName ?? defaultProps.fontFamily;
  const fontSize = spec.fontSize ?? defaultProps.fontSize;

  return {
    align,
    fill: color == null ? undefined : convertColorToCss(color),
    fontFamily,
    // Placeholder font size is in points and placeholder frame is in centimeters.
    // So first the points are converted to centimeters to match the frame.
    // Then the value is converted to pixels for Polotno.
    fontSize: fontSize == null ? undefined : convertPtToPx(fontSize, spec.dpi),
    verticalAlign: convertVerticalAlignToPolotno(verticalAlign),
  };
};

export default convertTextSpecToPolotno;
